import Log from '~/_Utility/Log';

import Async from '~/Async';

class Interest {

    /**
     * @since 2.0.0
     * @method constructor
     */
    constructor() {
        // Set up variables
        this.selector       = '[data-action="p3-toggle-interest"]';
        this.iconSelector   = '[data-interest-icon]';
        this.labelSelector  = '[data-interest-label]';
        this.iconOnData     = 'interest-icon-on';
        this.iconOffData    = 'interest-icon-off';
        this.classOnData    = 'interest-class-on';
        this.classOffData   = 'interest-class-off';
        this.labelOnData    = 'interest-label-on';
        this.labelOffData   = 'interest-label-off';
        this.idData         = 'interest-id';
        this.activeData     = 'interest-subscribe';
        this.disabledClass  = 'disabled';
        this.loadingClasses = this.disabledClass + ' opacity-5';

        // Get our async requestor
        this.async = new Async();

        // Run initialization
        this.init()
    }

    /**
     * Initialize the class.
     *
     * @method init
     * @since 2.0.0
     * @return void
     */
    init() {
        // Let them know we made it here OK
        new Log('Favorites initialized.', 'init');

        // Search for our elements
        $(this.selector).each((i, button) => {

            // Listen for the click
            button.addEventListener('click', (e, b) => {

                // Ignore whatever the default behavior is
                e.preventDefault();

                // If we are currently loading, do not do anything else
                if ($(button).hasClass(this.disabledClass))
                    return;

                // Declare and iniitlalize
                let self     = $(button);
                let active   = 'on' === self.data(this.activeData);
                let icon     = self.find(this.iconSelector)
                let label    = self.find(this.labelSelector);
                let iconOn   = self.data(this.iconOnData) || 'close';
                let iconOff  = self.data(this.iconOffData) || 'add';
                let classOn  = self.data(this.classOnData);
                let classOff = self.data(this.classOffData);
                let labelOn  = self.data(this.labelOnData) || 'Unsubscribe';
                let labelOff = self.data(this.labelOffData) || 'Subscribe';
                let id       = self.data(this.idData);

                // Toggle the data
                self.attr('data-' + this.activeData, active ? '' : 'on');
                self.data(this.activeData, active ? '' : 'on');

                // Toggle the icon
                icon.html(active ? iconOff : iconOn);

                // Toggle the classes
                self.attr('class', active ? classOff : classOn);

                // Disable this button for now
                self.addClass(this.loadingClasses);

                // Toggle the label
                label.text(active ? labelOff : labelOn)

                // Set a falback callback just in case we need it
                let fallback = () => {

                    // Revert the icon
                    icon.html(active ? iconOn : iconOff);

                    // Revert the classes
                    self.attr('class', active ? classOn : classOff);

                    // Revert the label
                    label.text(active ? labelOn : labelOff)

                }

                // Run the async post
                this.async.post('toggle-interest-subscribe', {
                    success: {
                        callback: () => self.removeClass(this.loadingClasses)
                    },
                    fail:    {
                        callback: fallback
                    },
                    params:  {
                        id: id
                    }
                });

            });

        });
    }
}

export default Interest;